import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";
import { checkHaveToken } from "constants/actionAccess";
import fetch from "../auth/FetchInterceptor";

const menuService = {};

menuService.getMenu = function () {
  return fetch({
    url: `${env.API_MSCSM}/api/menu/getMenu`,
    method: "get",
  });
};

// List Menu
menuService.listMenu = () => {
  if (!checkHaveToken()) {
    return false;
  }
  return fetchV2({
    url: `${env.API_MSCSM}/api/acl/get-menu-by-role`,
    method: "get",
  });
};

// List Function Role
menuService.listFunctionRole = ({ params = {} }) => {
  if (!checkHaveToken()) {
    return false;
  }
  return fetchV2({
    url: `${env.API_MSCSM}/api/function/get-function-role`,
    method: "get",
    params: {
      ...params,
    },
  });
};

export default menuService;
